import en from './en';
import id from './id';

const lang = {
    en,
    id,
};

export default lang;